/**
 * @file 通用loading
 */
import { Spin } from '@bfe/moly';

import styles from './index.module.scss';

export const Loading = () => {
  return (
    <div className={styles.container}>
      <Spin />
    </div>
  );
};
